import { useParams } from 'react-router-dom';
import { getPolyglot } from '../../../../i18n';
import { NavigationPath } from '../../../DeviceManager/navigations/navigationPath';

export function useNavigationPath(): NavigationPath[] {
  const params = useParams<{
    workspaceId: string;
  }>();
  const polyglot = getPolyglot();
  const sectionsNavigation: NavigationPath[] = [
    {
      content: polyglot.t('stoerk_id.nav_title'),
      href: '/account/my-account',
      key: 'my-account',
    },
    {
      content: polyglot.t('incident.policy.policy_create_button'),
      href: `account/my-account/workspace/${params.workspaceId}/policy/create`,
      key: 'policy-create',
    },
  ];

  return sectionsNavigation;
}
